import { Box, Container, Grid } from "@mui/material";
import "./MsShimmer.css";
import { MsSpinnerMotion } from "../MsSpinnerMotion";
function MsShimmer() {
  return (
    <Grid className="ms-set-password-container">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        <img src="/ciam/v1/static/images/ms/right-circle.svg" alt="right-circular-gradient" />
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box>
            <MsSpinnerMotion size="large" />
          </Box>
        </Container>
      </div>
    </Grid>
  );
}
export default MsShimmer;
